import { availabilityQueryKey } from "@/lib/shifts";
import { createClient } from "@/lib/supabase/client";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
const TODAY = new Date();

export default function Subscriptions({ origin }: { origin: string }) {
  const supabase = createClient();
  const queryClient = useQueryClient();

  useEffect(() => {
    const domainChannel = supabase
      .channel(`domain-channel-${origin}`)
      .on(
        "broadcast",
        {
          event: "update-online-order-timeslot",
        },
        (payload) => {
          queryClient.invalidateQueries({
            queryKey: availabilityQueryKey(TODAY),
          });
        }
      )
      .subscribe();
    return () => {
      domainChannel.unsubscribe();
    };
  }, []);
  return null;
}
